import React, { useState } from "react";
import "../../style/pages/categoriespage/knives.css";
import { useNavigate } from "react-router-dom";
import Header from "../../component/Header.jsx";
import Filter from "../../component/Filter.jsx";
import ItemGrid from "../../component/ItemGrid.jsx";

import k1 from "../../media3/categories/k1.png";
import k2 from "../../media3/categories/k2.png";
import k3 from "../../media3/categories/k3.png";
import k4 from "../../media3/categories/k4.png";
import k5 from "../../media3/categories/k5.png";
import k6 from "../../media3/categories/k6.png";
import k7 from "../../media3/categories/k7.png";
import k8 from "../../media3/categories/k8.png";
import k9 from "../../media3/categories/k9.png";
import k10 from "../../media3/categories/k10.png";
import k11 from "../../media3/categories/k11.png";
import k12 from "../../media3/categories/k12.png";
import k13 from "../../media3/categories/k13.png";
import k14 from "../../media3/categories/k14.png";
import k15 from "../../media3/categories/k15.png";
import k16 from "../../media3/categories/k16.png";
import k17 from "../../media3/categories/k17.png";
import k18 from "../../media3/categories/k18.png";
import k19 from "../../media3/categories/k19.png";
import k20 from "../../media3/categories/k20.png";
import k21 from "../../media3/categories/k21.png";
import k22 from "../../media3/categories/k22.png";
import k23 from "../../media3/categories/k23.png";
import k24 from "../../media3/categories/k24.png";
import k from "../../media3/categories/k.png";

// Dummy data
export const knivesData = [
  { id: 1, name: "Karambit | Slalom", img: k1, price: 61, maxPrice: 122, color: "purple", rating: 4, rarity: "Restricted", orderedBy: "Popularity", currency: "USD", description: "Karambit curved blade with purple and white Slalom ski-themed patterns, slashing through turns with alpine elegance and deadly precision." },
  { id: 2, name: "M9 Bayonet | Blaze", img: k2, price: 80, maxPrice: 150, color: "green", rating: 5, rarity: "Covert", orderedBy: "Price", currency: "USD", description: "M9 Bayonet engulfed in vivid green Blaze flames, burning through enemies with elite, fiery lethality." },
  { id: 3, name: "Butterfly Knife | Fade", img: k3, price: 95, maxPrice: 160, color: "yellow", rating: 4, rarity: "Classified", orderedBy: "Rating", currency: "USD", description: "Butterfly Knife with a stunning yellow-to-pink Fade gradient, flipping with chromatic grace and razor-sharp style." },
  { id: 4, name: "Bayonet | Orion", img: k4, price: 120, maxPrice: 180, color: "orange", rating: 5, rarity: "Covert", orderedBy: "Newest", currency: "USD", description: "Classic Bayonet adorned with cosmic orange Orion constellation patterns, piercing the night sky with stellar dominance." },
  { id: 5, name: "Talon Knife | See Ya Later", img: k5, price: 70, maxPrice: 125, color: "blue", rating: 3, rarity: "Restricted", orderedBy: "Popularity", currency: "USD", description: "Talon Knife featuring a mechanical blue 'See Ya Later' alligator, snapping shut on foes with robotic bite." },
  { id: 6, name: "Flip Knife | Hyper Beast", img: k6, price: 90, maxPrice: 140, color: "blue", rating: 4, rarity: "Classified", orderedBy: "Rating", currency: "USD", description: "Flip Knife roaring with monstrous blue Hyper Beast artwork, flipping open to unleash primal cutting fury." },
  { id: 7, name: "Gut Knife | Fuel Injector", img: k7, price: 110, maxPrice: 160, color: "blue", rating: 5, rarity: "Covert", orderedBy: "Price", currency: "USD", description: "Gut Knife with industrial blue Fuel Injector mechanics, gutting opponents with high-octane brutality." },
  { id: 8, name: "Huntsman Knife | Mel1", img: k8, price: 60, maxPrice: 120, color: "yellow", rating: 3, rarity: "Restricted", orderedBy: "Popularity", currency: "USD", description: "Huntsman Knife in bright yellow Mel1 watermelon-themed design, slicing with refreshing, fruity aggression." },
  { id: 9, name: "Bowie Knife | Llama Cannon", img: k9, price: 75, maxPrice: 130, color: "green", rating: 4, rarity: "Classified", orderedBy: "Newest", currency: "USD", description: "Massive Bowie Knife with explosive green Llama Cannon artwork, blasting into melee with quirky power." },
  { id: 10, name: "Karambit | Kill Confirmed", img: k10, price: 145, maxPrice: 200, color: "yellow", rating: 5, rarity: "Covert", orderedBy: "Price", currency: "USD", description: "Karambit marked by yellow Kill Confirmed bullet holes and blood—ultimate proof of curved, silent eliminations." },
  { id: 11, name: "M9 Bayonet | Bullet Queen", img: k11, price: 88, maxPrice: 150, color: "white", rating: 4, rarity: "Classified", orderedBy: "Rating", currency: "USD", description: "M9 Bayonet crowned with regal white Bullet Queen gold accents, ruling close combat with royal authority." },
  { id: 12, name: "Flip Knife | Handgun", img: k12, price: 55, maxPrice: 110, color: "blue", rating: 3, rarity: "Restricted", orderedBy: "Popularity", currency: "USD", description: "Flip Knife with compact blue Handgun pistol motifs, switching seamlessly between blade and sidearm inspiration." },
  { id: 13, name: "Gut Knife | Avalanche", img: k13, price: 68, maxPrice: 125, color: "black", rating: 4, rarity: "Restricted", orderedBy: "Newest", currency: "USD", description: "Gut Knife enduring black Avalanche snowstorm camouflage, hooking through blizzards with frozen resilience." },
  { id: 14, name: "Butterfly Knife | Xiangliu", img: k14, price: 92, maxPrice: 160, color: "red", rating: 4, rarity: "Classified", orderedBy: "Price", currency: "USD", description: "Butterfly Knife wrapped in red Xiangliu mythical serpent scales, flipping with ancient venom and grace." },
  { id: 15, name: "Talon Knife | Muertos", img: k15, price: 63, maxPrice: 120, color: "black", rating: 3, rarity: "Restricted", orderedBy: "Popularity", currency: "USD", description: "Talon Knife celebrating black Muertos with engraved skulls, a cultural claw for Day of the Dead duels." },
  { id: 16, name: "Huntsman Knife | Angry Mob", img: k16, price: 85, maxPrice: 140, color: "yellow", rating: 5, rarity: "Classified", orderedBy: "Rating", currency: "USD", description: "Huntsman Knife fueled by yellow Angry Mob riot graffiti, slashing through chaos with crowd-powered rage." },
  { id: 17, name: "Bowie Knife | Cobra Strike", img: k17, price: 78, maxPrice: 130, color: "white", rating: 4, rarity: "Classified", orderedBy: "Newest", currency: "USD", description: "Bowie Knife coiled in white Cobra Strike serpent design, striking with survivalist venom and power." },
  { id: 18, name: "Karambit | Crazy 8", img: k18, price: 59, maxPrice: 110, color: "yellow", rating: 2, rarity: "Restricted", orderedBy: "Popularity", currency: "USD", description: "Karambit spinning with yellow Crazy 8 dice and chaos motifs, gambling on unpredictable, wild cuts." },
  { id: 19, name: "M9 Bayonet | Ticket to Hell", img: k19, price: 99, maxPrice: 160, color: "red", rating: 5, rarity: "Classified", orderedBy: "Price", currency: "USD", description: "M9 Bayonet burning with red Ticket to Hell flames and demons, stabbing straight into infernal territory." },
  { id: 20, name: "Butterfly Knife | Water", img: k20, price: 115, maxPrice: 175, color: "blue", rating: 5, rarity: "Covert", orderedBy: "Newest", currency: "USD", description: "Butterfly Knife flowing with blue Water Elemental liquid effects, flipping like ocean waves in fluid motion." },
  { id: 21, name: "Flip Knife | Asiimov", img: k21, price: 102, maxPrice: 155, color: "white", rating: 4, rarity: "Classified", orderedBy: "Rating", currency: "USD", description: "Flip Knife in clean white Asiimov future-tech geometry, slicing with sci-fi precision and minimalist style." },
  { id: 22, name: "Gut Knife | Pole Position", img: k22, price: 66, maxPrice: 125, color: "yellow", rating: 3, rarity: "Restricted", orderedBy: "Popularity", currency: "USD", description: "Gut Knife in yellow Pole Position racing checkers, hooking victories with high-speed, track-ready hooks." },
  { id: 23, name: "Huntsman Knife | Isaac", img: k23, price: 74, maxPrice: 130, color: "white", rating: 4, rarity: "Classified", orderedBy: "Newest", currency: "USD", description: "Huntsman Knife with white Isaac holographic circuit patterns, hunting with electrified tactical edge." },
  { id: 24, name: "Talon Knife | Boost", img: k24, price: 97, maxPrice: 160, color: "red", rating: 5, rarity: "Covert", orderedBy: "Price", currency: "USD", description: "Talon Knife upgraded with red Boost Protocol cyber glow, clawing through combat at overclocked speeds." }
];

const colors = ["red", "green", "blue", "yellow", "purple", "black", "white", "orange"];
const ratings = [5, 4, 3, 2, 1];

function Knives({ isLoggedIn, setLoginModalOpen, handleLogout }) {
  const [priceRange, setPriceRange] = useState([50, 200]);
  const [selectedColors, setSelectedColors] = useState([]);
  const [selectedRating, setSelectedRating] = useState(null);
  const [openFilter, setOpenFilter] = useState("Price");
    const [selectedRarity, setSelectedRarity] = useState(null);
  const [selectedOrderBy, setSelectedOrderBy] = useState(null);

  const navigate = useNavigate();

  // Filtering
  // const filteredKnives = knivesData.filter((knife) => {
  //   const inPrice = knife.price >= priceRange[0] && knife.price <= priceRange[1];
  //   const inColor = selectedColors.length === 0 || selectedColors.includes(knife.color);
  //   const inRating = !selectedRating || knife.rating === selectedRating;
  //   return inPrice && inColor && inRating;
  // });

  let filteredKnives = knivesData.filter((pistol) => {
    const inPrice = pistol.price >= priceRange[0] && pistol.price <= priceRange[1];
    const inColor = selectedColors.length === 0 || selectedColors.includes(pistol.color);
    const inRating = !selectedRating || pistol.rating === selectedRating;
    const inRarity = !selectedRarity || selectedRarity === "Any" || pistol.rarity === selectedRarity;
    return inPrice && inColor && inRating && inRarity;
  });
  
  // Add sorting
  if (selectedOrderBy) {
    filteredKnives = [...filteredKnives].sort((a, b) => {
      switch (selectedOrderBy) {
        case "Price":
          return a.price - b.price;
        case "Rating":
          return b.rating - a.rating;
        case "Popularity":
          return a.id - b.id;
        case "Newest":
          return b.id - a.id;
        default:
          return 0;
      }
    });
  }
  
  const handleRarityChange = (rarity) => {
    setSelectedRarity(rarity === selectedRarity ? null : rarity);
  };
  
  const handleOrderByChange = (orderBy) => {
    setSelectedOrderBy(orderBy === selectedOrderBy ? null : orderBy);
  };

  // Handlers
  const handlePriceChange = (e, idx) => {
    const newRange = [...priceRange];
    newRange[idx] = Number(e.target.value);
    setPriceRange(newRange);
  };

  const handleColorChange = (color) => {
    setSelectedColors((prev) =>
      prev.includes(color) ? prev.filter((c) => c !== color) : [...prev, color]
    );
  };
    const handleNavigate = (itemName) => {
    navigate(`/items/${encodeURIComponent(itemName)}`);
  };

  const handleRatingChange = (rating) => {
    setSelectedRating(rating === selectedRating ? null : rating);
  };

  const toggleSection = (section) => {
    setOpenFilter(openFilter === section ? "" : section);
  };

  return (
    <div className="categories-page">
      <Header
        isLoggedIn={isLoggedIn}
        setLoginModalOpen={setLoginModalOpen}
        handleLogout={handleLogout}
      />
      <div className="categories-content">
          <Filter
          openFilter={openFilter}
          toggleSection={toggleSection}
          priceRange={priceRange}
          handlePriceChange={handlePriceChange}
          selectedColors={selectedColors}
          handleColorChange={handleColorChange}
          selectedRating={selectedRating}
          handleRatingChange={handleRatingChange}
          colors={colors}
          ratings={ratings}
           selectedRarity={selectedRarity}
  handleRarityChange={handleRarityChange}
  selectedOrderBy={selectedOrderBy}
  handleOrderByChange={handleOrderByChange}
        />
        <ItemGrid
          items={filteredKnives}
          categoryImage={k}
          categoryAlt="CZ75-Auto"
          categoryTitle="Talon 9 | Boost"
          categoryDescription="Step into the spotlight with our exclusive collection of CS2 Knife skins.
          From sleek tactical blades to rare, eye-catching finishes, each knife defines true in-game prestige.
          Crafted for collectors and competitors alike, these weapons combine style, rarity, and precision.
          Own the edge — because every strike deserves a statement."
          onItemClick={handleNavigate}
            isLoggedIn={isLoggedIn}                   
          setLoginModalOpen={setLoginModalOpen}
        /> 
      </div>
    </div>
  );
}

export default Knives;